var ImageResizeMode = {
  center: 'center',
  contain: 'contain',
  cover: 'cover',
  none: 'none',
  repeat: 'repeat',
  stretch: 'stretch'
};

export default ImageResizeMode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/exports/Image/ImageResizeMode.js
// module id = 254
// module chunks = 2